<script lang="ts">
    import { TranslationOptions } from "@modules/i18n/GwI18n/types";
    import { I18nModule } from "@modules/i18n/I18nModule";
    import { container } from "tsyringe";

    export let translationKey: string;
    export let namespace: string;
    export let translationOptions: TranslationOptions | undefined = undefined;
    const i18nModule = container.resolve(I18nModule);

    $: translation$ = i18nModule.exports.i18n.selectT(
        namespace,
        translationKey,
        translationOptions
    );
</script>

<slot translation={$translation$}>
    {@html $translation$ || ""}
</slot>
